import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22.5 7.93725C22.5 4.797 19.9688 2.25 16.8465 2.25C14.7855 2.25 12.9878 3.36225 12 5.019C11.0122 3.36225 9.2145 2.25 7.1535 2.25C4.03125 2.25 1.5 4.797 1.5 7.93725C1.5 15.2498 12 21.75 12 21.75C12 21.75 22.5 15.2498 22.5 7.93725Z" // eslint-disable-line
 }), 'FavoriteFilled');
